import { validateMaximum } from 'hb-react/shared/utils/validators/maximum';
import { validateMaximumNumberOfDecimals } from 'hb-react/shared/utils/validators/maximumNumberOfDecimals';
import { validateMaxLength } from 'hb-react/shared/utils/validators/maxLength';
import { validateMinimum } from 'hb-react/shared/utils/validators/minimum';
import { validateRequired } from 'hb-react/shared/utils/validators/required';

export const validateHidden = ({
  value,
  required,
  minimum,
  maximum,
  maxLength,
  maximumNumberOfDecimals,
  validateFunc,
}) => {
  let error;

  if (required) {
    error = validateRequired(value);
  }

  if ((minimum || minimum === 0) && !error) {
    error = validateMinimum(value, minimum);
  }

  if ((maximum || minimum === 0) && !error) {
    error = validateMaximum(value, maximum);
  }

  if (maxLength && !error) {
    error = validateMaxLength(value, maxLength);
  }

  if ((maximumNumberOfDecimals || maximumNumberOfDecimals === 0) && !error) {
    error = validateMaximumNumberOfDecimals(value, maximumNumberOfDecimals);
  }

  if (validateFunc) {
    error = validateFunc(value);
  }

  return error;
};
